import { lazy, Suspense } from 'react';
import { LoadingSpinner } from './LoadingSpinner';

// Lazy load heavy features
const ContoursPanel = lazy(() => import('../features/contours/components/ContoursPanel'));
const ChartsDisplayPanel = lazy(() => import('../features/charts/components/ChartsDisplayPanel'));

interface LazyFeatureLoaderProps {
  feature: 'contours' | 'charts-display';
  [key: string]: unknown;
}

export const LazyFeatureLoader: React.FC<LazyFeatureLoaderProps> = ({ feature, ...props }) => {
  switch (feature) {
    case 'contours':
      return (
        <Suspense fallback={<LoadingSpinner />}>
          <ContoursPanel {...props} />
        </Suspense>
      );
    case 'charts-display':
      return (
        <Suspense fallback={<LoadingSpinner />}>
          <ChartsDisplayPanel isVisible={true} {...props} />
        </Suspense>
      );
    default:
      return <div>Unknown feature</div>;
  }
};

// Export individual lazy components for direct use
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyContoursPanel = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <ContoursPanel {...props} />
  </Suspense>
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyChartsDisplayPanel = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <ChartsDisplayPanel isVisible={true} {...props} />
  </Suspense>
);

